import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NAV_OFFSET_PX = 88; // sticky site-nav (~5.5rem)

/**
 * Scroll to top on route change, or to #hash targets.
 * Manual scrollRestoration + retries: SPA navigations from a scrolled page
 * (e.g. homepage → /product#journey) otherwise keep the old window.scrollY
 * and land mid-page.
 */
export default function ScrollToHash() {
  const { pathname, hash, key } = useLocation();

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const run = () => {
      if (!hash) {
        window.scrollTo(0, 0);
        return;
      }

      const id = decodeURIComponent(hash.slice(1));
      const el = document.getElementById(id);
      if (!el) {
        window.scrollTo(0, 0);
        return;
      }

      const top = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET_PX;
      window.scrollTo(0, Math.max(0, top));
    };

    run();
    const raf = requestAnimationFrame(run);
    const t1 = window.setTimeout(run, 50);
    const t2 = window.setTimeout(run, 200);

    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [pathname, hash, key]);

  return null;
}
